import React from 'react';
import chatRobot from '@/imgs/chat-robot.png';
interface AvatarProps {
  className?: string;
}

const Avatar: React.FC<AvatarProps> = ({ className = '' }) => {
  return (
    <div className={`relative ${className}`}>
      <div className="h-[52px] w-[52px] rounded-full bg-[linear-gradient(270deg,#3215F3_0%,#FF4876_100%)] p-[1px]">
        <img src={chatRobot} alt="" width={52} height={52} />
      </div>
    </div>
  );
};

export default Avatar;
